var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1422_44527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20.5,
    width: 20,
    height: 20,
    transform: "rotate(-90 0 20.5)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1422_44527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 8.43733L3.87516 14.5623C3.66683 14.7707 3.4203 14.8714 3.13558 14.8644C2.85086 14.8575 2.60433 14.7498 2.396 14.5415C2.18766 14.3332 2.0835 14.0866 2.0835 13.8019C2.0835 13.5172 2.18766 13.2707 2.396 13.0623L8.81266 6.66649C8.97933 6.49983 9.16683 6.37483 9.37516 6.29149C9.5835 6.20816 9.79183 6.16649 10.0002 6.16649C10.2085 6.16649 10.4168 6.20816 10.6252 6.29149C10.8335 6.37483 11.021 6.49983 11.1877 6.66649L17.6043 13.0832C17.8127 13.2915 17.9134 13.5345 17.9064 13.8123C17.8995 14.0901 17.7918 14.3332 17.5835 14.5415C17.3752 14.7498 17.1286 14.854 16.8439 14.854C16.5592 14.854 16.3127 14.7498 16.1043 14.5415L10.0002 8.43733Z",
    fill: "#01BCD4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron_up.4acad8ca8681580b373c3fa279230cf9.svg";
export { ForwardRef as ReactComponent };